<template>
  <require from="framework/value_converters/hide-by-property"></require>
  <require from="controls/bs-nav-item"></require>

  <div class="nav-item" show.bind="heading || headingIcon">
    <span class="nav-heading">
      <slot name="heading">
        <i class.bind="headingIcon" title.bind="heading || ''" if.bind="headingIcon"></i> ${heading}
      </slot>
    </span>
  </div>
  <div class="nav-item ${item.isActive ? 'active' : ''} ${item.settings.disabled ? 'disabled' : ''} ${item.settings.itemClass}" repeat.for="item of navigation | hideByProperty:'settings.hidden' & signal:'navigation-changed'">
    <div as-element="bs-nav-item" item.bind="item" link-clicked.call="linkClicked(nav)"></div>
  </div>
</template>
